import { useQuery } from "@tanstack/react-query"

import { QUALITY_PASSPORT_QUERY_KEY } from "@/constants/query"
import { getQualityPassportById, getQualityPassports } from "@/http/qualityPassport"

import { IRequestParams } from "@/types/api"


export const useQualityPassportQuery = (params?: IRequestParams) => {
  return useQuery({
    queryFn: () => getQualityPassports(params || {}),
    queryKey: [QUALITY_PASSPORT_QUERY_KEY, params],
    retry: false
  })
}

export const useQualityPassportByIdQuery = (id: number) => {
  return useQuery({
    queryFn: () => getQualityPassportById(id),
    queryKey: [QUALITY_PASSPORT_QUERY_KEY, id],
    enabled: !!id
  })
}